var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPublicBathroomMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 63,
    viewBox: "0 0 58 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2054_1023)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4082 5C10.9736 5 9 6.9736 9 9.40816V40.5918C9 43.0264 10.9736 45 13.4082 45H25.1509L27.0911 48.3605C27.9395 49.8299 30.0603 49.8299 30.9087 48.3605L32.8489 45H44.5918C47.0264 45 49 43.0264 49 40.5918V9.40816C49 6.9736 47.0264 5 44.5918 5H13.4082Z",
    fill: "#005682"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2054_1023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3333 14.3333C34.3333 12.8533 35.52 11.6667 37 11.6667C38.48 11.6667 39.6666 12.8533 39.6666 14.3333C39.6666 15.8133 38.48 17 37 17C35.52 17 34.3333 15.8133 34.3333 14.3333ZM39.6666 38.3333V30.3333H43L39.6133 20.16C39.24 19.0667 38.2266 18.3333 37.08 18.3333H36.92C35.7733 18.3333 34.7466 19.0667 34.3866 20.16L33.24 23.6C34.68 24.4 35.6666 25.9067 35.6666 27.6667V38.3333H39.6666ZM29.6666 24.3333C30.7733 24.3333 31.6666 23.44 31.6666 22.3333C31.6666 21.2267 30.7733 20.3333 29.6666 20.3333C28.56 20.3333 27.6666 21.2267 27.6666 22.3333C27.6666 23.44 28.56 24.3333 29.6666 24.3333ZM20.3333 17C21.8133 17 23 15.8133 23 14.3333C23 12.8533 21.8133 11.6667 20.3333 11.6667C18.8533 11.6667 17.6666 12.8533 17.6666 14.3333C17.6666 15.8133 18.8533 17 20.3333 17ZM23 38.3333V29H25V21C25 19.5333 23.8 18.3333 22.3333 18.3333H18.3333C16.8666 18.3333 15.6666 19.5333 15.6666 21V29H17.6666V38.3333H23ZM31.6666 38.3333V33H33V27.6667C33 26.5733 32.0933 25.6667 31 25.6667H28.3333C27.24 25.6667 26.3333 26.5733 26.3333 27.6667V33H27.6666V38.3333H31.6666Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2054_1023",
    x: 0.183673,
    y: 0.591836,
    width: 57.6327,
    height: 64.2993,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.40816
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.40816
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2054_1023"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.40816
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.40816
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2054_1023",
    result: "effect2_dropShadow_2054_1023"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2054_1023",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2054_1023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(13 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicBathroomMarker);
export default __webpack_public_path__ + "static/media/public_bathroom_marker.dc41d51c6341ca736a2f1df8afb8506a.svg";
export { ForwardRef as ReactComponent };